import React, { Fragment, useState } from 'react'
import { flatMap } from 'lodash'
import PropTypes from 'prop-types'
import Table from 'UI/Table'

import { vmColumns, customerColumns } from './Columns'
import { Filters, defaultFilters } from './Filters'
import filteredVMData from './Data'

const VMIntegrationCoverage = ({ vms = [] }) => {
  const [filters, changeFilters] = useState(defaultFilters)
  const data = filteredVMData({ vms, filters })

  const tableData = {
    data,
    columns: customerColumns(),
    className: 'table',
    defaultSorted: [{ id: 'customer_name', asc: true }],
    SubComponent: (row) => (
      <Table
        filterable
        data={row.original.vms}
        columns={vmColumns()}
      />
    )
  }

  return (
    <Fragment>
      <Filters {...{ filters, changeFilters, vms: flatMap(vms, 'vms') }} />

      <Table {...tableData} />
    </Fragment>
  )
}

export default VMIntegrationCoverage
